<template>
  <div class="order_sub_bar flex-r-sb-c">
    <div class="left_btn flex-r-s-c">
      <!-- <div class="order_money_item flex-r-c-c">
        <div style="width:1rem">合计：</div>
        <div style="color:#ED0D0D;">￥</div>
        <div style="color:#ED0D0D;font-size:0.48rem">{{ retotal }}</div>
      </div> -->
    </div>
    <!-- 针对直接线下转账的特殊处理 -->
    <div v-if="info.payStatus === 0 && info.payWay === 2 " class="right_btn flex-r-s-s">
      <van-button round block type="info" color="#0767ab" style="margin-left:0.3rem;width:3rem" @click="action('bank')">
        已转账付款</van-button>
      <van-button v-clipboard:copy="'收款公司：'+bankInfo.company+' 开户银行：'+bankInfo.bankName+' 收款账号：'+bankInfo.bankAccount +' 转账备注：'+ bankInfo.notes"
                  v-clipboard:success="onCopy" v-clipboard:error="onError" round block type="info" color="#CB8552"
                  style="margin-left:0.3rem;width:3.2rem" @click="action('copy')"
      >复制转账信息</van-button>
    </div>
    <div v-if="info.payFlag " class="right_btn flex-r-s-s">
      <van-button round block plain type="info" color="#0767ab" @click="action('cancer')"> 取消订单</van-button>
      <van-button v-if="info.addressFlag" round block plain type="info" color="#0767ab" style="margin-left:0.3rem" @click="action('address')">
        {{ ischangeAddress?'确认修改':'修改地址' }}</van-button>
      <van-button round block type="info" color="#0767ab" style="margin-left:0.3rem" @click="action('pay')">去付款
      </van-button>
    </div>
    <div v-else class="right_btn flex-r-s-s">
      <!-- <van-button v-if="info.expressFlag" round block plain type="info" color="#0767ab" @click="action('express')">查看物流
      </van-button> -->
      <van-button v-if="info.copyFlag" round block plain type="info" color="#0767ab" style="margin-left:0.3rem"
                  @click="action('new')"
      >再来一单</van-button>
      <!-- <van-button v-if="info.refundFlag" round block type="info" color="#0767ab" style="margin-left:0.3rem" @click="action('return')">我要退款</van-button>
      <van-button v-if="info.refundZer0Flag" round block type="info" color="#0767ab" style="margin-left:0.3rem" @click="action('returnInfo')">退款进度</van-button> -->
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['info', 'bankInfo'],
  data() {
    return {
      ischangeAddress: false,
      onError: ''
    }
  },
  methods: {
    // 底部行为
    action(type) {
      if (type === 'address') { this.ischangeAddress = !this.ischangeAddress }
      this.$emit('action', type)
    },
    onCopy() { this.$toast('已复制于剪切板！') }
  }
}
</script>

<style lang="scss">
.order_sub_bar {
  border-top: 1px solid rgb(214, 214, 214);
  position: fixed;
  width: 10rem;
  height: 1.71rem;
  background: #ffffff;
  opacity: 1;
  border-radius: 0rem;
  bottom: 0;
  .left_btn {
    width: 30%;
    padding-left: 0.3rem;
    .left_btn_item {
      font-size: 0.52rem;
      color: #686868;
    }
    .order_money_item {
      margin-left: 0.3rem;
      div {
        font-size: 0.32rem;
        line-height: 0.81rem;
        color: #333333;
      }
    }
    span {
      font-size: 0.32rem;
      font-weight: 400;
      color: #686868;
    }
  }
  .right_btn {
    font-size: 0.37rem;
    line-height: 1.17rem;
    color: #ffffff;
    padding-right: 0.3rem;
    .van-button {
      width: 2.57rem;
      height: 1.03rem;
    }
  }
}
</style>
